module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="js-paginator-container whiteBox whiteBox-withSections">\n    <div class="js-paginator-list-container"></div>\n    <div class="t-paginator-load-more js-paginator-load-more"></div>\n</div>\n';
}
return __p;
};
